// extracted by mini-css-extract-plugin
export var LGridbox = "blog-module--LGridbox--15b98";
export var articleCount = "blog-module--articleCount--a0d88";
export var blogContentContainer = "blog-module--blogContentContainer--9116f";
export var blogHeroSection = "blog-module--blogHeroSection--63620";
export var blogPostContainer = "blog-module--blogPostContainer--397d3";
export var moreArticles = "blog-module--moreArticles--46f6a";
export var moreArticlesContainer = "blog-module--moreArticlesContainer--42e01";
export var pageNumbersContainer = "blog-module--pageNumbersContainer--ec47f";